import { render, staticRenderFns } from "./TireRecommender.vue?vue&type=template&id=ce6f5154"
import script from "./TireRecommender.vue?vue&type=script&setup=true&lang=ts"
export * from "./TireRecommender.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TireRecommender.vue?vue&type=style&index=0&id=ce6f5154&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports